/* Copy da área Contas (components/accounts/): painel de @username reservados (ADR-0730). */
import type { Bilingual } from '../bilingual.js';
import { useBilingual } from '../locale-provider.js';

interface AccountsContent {
  readonly reservedUsernames: {
    readonly title: string;
    readonly description: string;
    readonly loadError: string;
    readonly empty: string;
    readonly removeAriaLabel: (username: string) => string;
    readonly newHandlePlaceholder: string;
    readonly add: string;
    readonly invalidUsername: string;
    readonly alreadyReserved: string;
    readonly saveError: string;
  };
}

const ACCOUNTS_CONTENT: Bilingual<AccountsContent> = {
  'pt-BR': {
    reservedUsernames: {
      title: 'Nomes de usuário reservados',
      description:
        'Handles (@username) que ninguém pode reivindicar. A lista é gerida aqui (config-service) ' +
        '— nada hardcoded. Handles estruturais (admin, api, root…) seguem sempre reservados por ' +
        'segurança, mesmo que removidos daqui.',
      loadError: 'Falha ao carregar os nomes de usuário reservados.',
      empty: 'Nenhum nome de usuário reservado.',
      removeAriaLabel: (username) => `Remover ${username}`,
      newHandlePlaceholder: 'novo_handle',
      add: 'Adicionar',
      invalidUsername: 'Nome de usuário inválido. Use minúsculas, números e _ (3 a 30 caracteres).',
      alreadyReserved: 'Este nome de usuário já está reservado.',
      saveError: 'Não foi possível salvar os nomes de usuário reservados.',
    },
  },
  'en-US': {
    reservedUsernames: {
      title: 'Reserved usernames',
      description:
        'Handles (@username) nobody can claim. The list is managed here (config-service) — ' +
        'nothing hardcoded. Structural handles (admin, api, root…) always stay reserved for ' +
        'security, even if removed from here.',
      loadError: 'Failed to load reserved usernames.',
      empty: 'No reserved usernames.',
      removeAriaLabel: (username) => `Remove ${username}`,
      newHandlePlaceholder: 'new_handle',
      add: 'Add',
      invalidUsername:
        'Invalid username. Use lowercase letters, numbers and _ (3 to 30 characters).',
      alreadyReserved: 'This username is already reserved.',
      saveError: 'Could not save the reserved usernames.',
    },
  },
};

export const useAccountsContent = (): AccountsContent => useBilingual(ACCOUNTS_CONTENT);
